<div class="p-4">
  <div class="" *ngIf="userSubscriptionDetails">
    <app-customer-details-header-v2 [displaySubTypeLink]="displaySubTypeLink"
      [userSubscriptionDetails]="userSubscriptionDetails">
    </app-customer-details-header-v2>
  </div>
  <div>
    <div class="error-container mb16 error-border" *ngIf="(isServiceError)">
      <div class="message-center border-box">
        <img alt="red cross error image" aria-hidden="true" class="red-cross-error-icon"
          src="ocsp-web-ui/dist/assets/images/error-close-icon.svg">
        <span class="error-messages-center">{{errorMessage}}</span>
      </div>
    </div>
    <app-change-plan *ngIf="userSubscriptionDetails && !updatePlan && fetchedPlans"
      [currentEnvironment]="currentEnvironment" [userInfo]="userInfo"
      [userSubscriptionDetails]="userSubscriptionDetails" [fetchedPlans]="fetchedPlans">
    </app-change-plan>
  </div>
  <div *ngIf="showLoader" class="row">
    <div class="col-lg-6 col-md-12">
      <div class="loading-div-tiny" id="freshpass-loading">
        <div class="loading-spinner">
          <div class="large progress">
            <div class="prog1">
              <div class="prog2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!showLoader">
    <payment-modal *ngIf="updatePlan" [changeCode]="changeCode" [retentionPlanDiscount]="retentionPlanDiscount"
      [currentEnvironment]="currentEnvironment" [userEnrollmentDetails]="userEnrollmentDetails"
      [tenderInfo]="tenderInfo" [termsID]="termsID" [userInfo]="userInfo"></payment-modal>
  </div>

  <div *ngIf="!showLoader && !updatePlan">
    <div class="row">
      <ng-container *ngIf="combinedPlans">
        <ng-container *ngIf="combinedPlans.length >= 3">
          <div class="mb-3" *ngFor="let plan of combinedPlans; let i = index" [ngClass]="{
              'col-12': i === 0,
              'col-lg-6 col-sm-12 col-md-12': i > 0 && i < 3
            }">
            <app-plan-card [cardType]='cardType' [planCard]="plan"
              (actionChange)="changePlan(plan.details?.code, plan.title)"></app-plan-card>
          </div>
        </ng-container>
        <ng-container *ngIf="combinedPlans.length <= 2">
          <div class="col-12 mb-3" *ngFor="let plan of combinedPlans">
            <app-plan-card [cardType]='cardType' [planCard]="plan"
              (actionChange)="changePlan(plan.details?.code, plan.title)"></app-plan-card>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>